export const SOLID_BACKGROUND_VIDEO_GENERATE_STATE = {
  PENDING: 'PENDING',
  EXPORTING: 'EXPORTING',
  EXPORTED: 'EXPORTED',
  PROJECT_CREATING: 'PROJECT_CREATING',
  PROJECT_CREATED: 'PROJECT_CREATED',
  ERROR: 'ERROR',
} as const

export type SolidBackgroundVideoGenerateState =
  keyof typeof SOLID_BACKGROUND_VIDEO_GENERATE_STATE

/**
 * 올리비아 Olivia
 */
export const DEFAULT_MODEL_ID = 'M000188857'

/**
 * 5분 (unit: ms)
 */
export const AUDIO_SCRIPT_MAX_DURATION = 1000 * 60 * 5
/**
 * 100mb (unit: byte)
 */
export const AUDIO_SCRIPT_MAX_SIZE = 1024 * 1024 * 100

export const TEXT_SCRIPT_TEMPOS = [
  '0.5',
  '0.6',
  '0.7',
  '0.8',
  '0.9',
  '1.0',
  '1.1',
  '1.2',
  '1.3',
  '1.4',
  '1.5',
  '1.6',
  '1.7',
  '1.8',
  '1.9',
  '2.0',
] as const
export type TextScriptTempo = (typeof TEXT_SCRIPT_TEMPOS)[number]

export const DEFAULT_PROJECT_NAME = 'untitled project'

export const DEFAULT_BACKGROUND_COLOR = '#3e7425'

export const ORIENTATION = {
  PORTRAIT: 'PORTRAIT',
  LANDSCAPE: 'LANDSCAPE',
} as const
export type Orientation = (typeof ORIENTATION)[keyof typeof ORIENTATION]

export const SCRIPT_TYPE = {
  TEXT: 'TEXT',
  AUDIO: 'AUDIO',
} as const
export type ScriptType = (typeof SCRIPT_TYPE)[keyof typeof SCRIPT_TYPE]

export const MODEL_POSITION = {
  [ORIENTATION.LANDSCAPE]: {
    top: 102.71196783306596,
    left: 674.896161476117,
    scaleX: 1,
    scaleY: 1,
  },
  [ORIENTATION.PORTRAIT]: {
    top: 142.90868914454154,
    left: 256.9917192214464,
    scaleX: 1,
    scaleY: 1,
  },
} as const
